import { type Middleware, type MiddlewareAPI } from '@reduxjs/toolkit';

import type { RootLogger } from 'loglevel';

export type RTKQueryAction = {
  error?: {
    message: string;
    name: string;
  };
  type: string;
  meta: {
    arg: {
      endpointName: string;
    };
    requestStatus: string;
  };
};

const isRTKQueryAction = (action: unknown): action is RTKQueryAction => {
  return (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    'meta' in action &&
    typeof action.meta === 'object' &&
    action.meta !== null &&
    'arg' in action.meta &&
    'requestStatus' in action.meta &&
    typeof action.meta.arg === 'object' &&
    action.meta.arg !== null &&
    'endpointName' in action.meta.arg &&
    typeof action.type === 'string' &&
    Boolean(action.meta.requestStatus) &&
    Boolean(action.type.split('/')[1])
  );
};

export const buildBusinessServicesLoggerMiddleware = (
  getLogger: RootLogger['getLogger'],
): Middleware => {
  const logger = getLogger('business-services');

  return (_api: MiddlewareAPI) => (next) => (action: unknown) => {
    try {
      if (isRTKQueryAction(action)) {
        const serviceName = action.type.split('/')[0] as string;
        const endpointName = action.meta.arg.endpointName;
        const requestStatus = action.meta.requestStatus;
        const messageContext = `${serviceName} ${endpointName}`;

        if (action.error !== undefined) {
          logger.error(`${messageContext}`, {
            requestStatus,
            error: action.error,
          });
        }
      }
    } catch (error) {
      logger.error('Unexpected error:', { error });
    } finally {
      next(action);
    }
  };
};
